import { useEffect, useRef, useState } from "react";
import { getTime } from '../../../utils/utils';

interface ClockProps {
	onMinute?: (...args: any[]) => any;
	onSecond?: (...args: any[]) => any;
}

export default function Clock({ onMinute, onSecond }: ClockProps): JSX.Element {
	const [timeString, setTimeString] = useState<string>(getTime());
	const second = useRef<number>(0);

	useEffect(() => {
		const clock = setInterval(() => {
			if (++second.current % 60 === 0 && onMinute) {
				onMinute();
			}

			if (onSecond) {
				onSecond();
			}

			setTimeString(getTime());
		}, 1000);

		return () => {
			clearInterval(clock);
		};
	}, [onMinute, onSecond]);

	return (<>{timeString}</>);
}